import { VEventEnum } from "quickfire/v/enums";
import { Signal } from "signals";
import Logger from "slotworks/utils/logger";

class QFSignals {

    private signals: Map<string, Signal> = new Map<string, Signal>();

    public init() {
        V.API.Events.subscribe("gameEvent", this.gameEventHandler, this);
    }

    public get(event: VEventEnum) {
        let signal;

        if (this.signals.has(event)) {
            signal = this.signals.get(event);
        } else {
            signal = new Signal();
            this.signals.set(event, signal);
        }

        return signal;
    }

    public dispatch(eventName: VEventEnum, data?: any) {
        this.log(`Dispatched: ${eventName}`);
        V.API.Events.sendEvent("gameEvent", V.API.Events.getEventsList("gameEvent")[eventName], data);
    }

    private gameEventHandler(eventName: string, data: any) {
        if (this.signals.has(eventName)) {
            this.signals.get(eventName).dispatch(data);
        }
    }

    private log(message: string) {
        Logger.info("%c Quickfire V Signal ", "background: #ffb347; color: #fff", message);
    }
}

export default new QFSignals();
